import type { PersistedClient, Persister } from '@tanstack/react-query-persist-client';
import { del, get, set } from 'idb-keyval';

/**
 * Creates an Indexed DB persister for react-query.
 * Based on https://github.com/TanStack/query/discussions/3198
 */
export function createReactQueryIDBPersister(input: {
    key: IDBValidKey;
    staleTime?: number;
}): Persister {
    const { key, staleTime } = input;
    return {
        persistClient: async (client: PersistedClient) => {
            await set(key, client);
        },
        restoreClient: async () => {
            const client = await get<PersistedClient>(key);

            // Make queries stale when restoring the client.
            if (client && staleTime !== undefined) {
                client.clientState.queries.forEach((query) => {
                    query.state.dataUpdatedAt = Date.now() - staleTime;
                });
            }

            return client;
        },
        removeClient: async () => {
            await del(key);
        },
    } as Persister;
}
